import { apiPromiseTypes } from 'redux/middleware/api-promise/action-types';

export const AMEND_COMPLETE = 'waitrose/orders/AMEND_PENDING';
export const CANCEL_AMEND = apiPromiseTypes('cancelAmendOrder', 'post');
export const CHANGE_SLOT_AMEND = apiPromiseTypes('changeSlotAmend', 'post');
export const START_AMEND = apiPromiseTypes('amendOrder', 'post');
